(function($){
    window.Forms.Validators.ClassOnlyValidator = $.extend(true, $.extend(true, {}, Forms.Validators.BaseValidator), {
        onError: function (el, message) {

            var $el = $(el);
            var $wrappers = $el.parents('.js-form__pair')

            // always reaply the error class, to allow CSS animations to replay
            $el.removeClass('error');
            $wrappers.removeClass('error');

            setTimeout(function(){

                $el.focus();
                $el.attr('data-error-message', message);
                $el.addClass('error');

                $wrappers.addClass('error');

            }, 10);

        },
        onSuccess: function (el) {

            var $el = $(el);
            var $wrappers = $el.parents('.js-form__pair')

            $el.removeAttr('data-error-message');
            $el.removeClass('error');

            $wrappers.removeClass('error');
        }
    });
})(jQuery);